<template>
    <el-badge :value="unreadList.length" :max="99" :hidden="unreadList.length == 0" class="item">
        <el-popover placement="right" width="400" trigger="click" v-model="popoverVisible">
            <el-button
                slot="reference"
                type="text"
                size="small"
                icon="el-icon-message-solid"
                class="p-5px toggle-btn"
                style="font-size: 16px; color: white"
            >
            </el-button>

            <div v-if="selectedPane == 0">
                <el-tabs v-model="activeName">
                    <el-tab-pane :label="$t('Unread Messages')" name="unread">
                        <el-row type="flex" justify="flex-start" class="mb-1">
                            <el-button
                                type="primary"
                                size="small"
                                v-if="unreadList.length"
                                @click="markAllRead()"
                                class="p-5px"
                                >{{ $t('Mark as all read') }}</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                v-if="selections.length"
                                @click="markSelectedAllRead()"
                                class="p-5px"
                                >{{ $t('Mark as read') }}</el-button
                            >
                        </el-row>
                        <el-table
                            :data="unreadList"
                            class="w-100 mb-2 notif-table"
                            :show-header="false"
                            @selection-change="handleSelectionChange"
                            max-height="500"
                        >
                            <el-table-column type="selection" width="25"></el-table-column>
                            <el-table-column show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div
                                        :class="{ 'font-weight-bold': scope.row.isUnread }"
                                        class="notif-row cursor-pointer"
                                        @click="openDetail(scope.row)"
                                    >
                                        {{ scope.row.title }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column width="75" align="right">
                                <template slot-scope="scope">
                                    <span :class="{ 'font-weight-bold': scope.row.isUnread }">
                                        <div>
                                            {{ moment(scope.row.record_date_utc).format('MMM DD') }}
                                        </div>
                                        <div>
                                            {{ moment(scope.row.record_date_utc).format('HH:mm') }}
                                        </div>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('Read Messages')" name="read">
                        <el-table
                            :data="readList"
                            class="w-100 mb-2 notif-table"
                            :show-header="false"
                            max-height="500"
                        >
                            <el-table-column show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div
                                        :class="{ 'font-weight-bold': scope.row.isUnread }"
                                        class="notif-row cursor-pointer"
                                        @click="openDetail(scope.row)"
                                    >
                                        {{ scope.row.title }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column width="75" align="right">
                                <template slot-scope="scope">
                                    <span :class="{ 'font-weight-bold': scope.row.isUnread }">
                                        <div>
                                            {{ moment(scope.row.record_date_utc).format('MMM DD') }}
                                        </div>
                                        <div>
                                            {{ moment(scope.row.record_date_utc).format('HH:mm') }}
                                        </div>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div v-else>
                <el-card shadow="never">
                    <div slot="header">
                        <el-button
                            class="p-5px"
                            size="mini"
                            type="text"
                            icon="el-icon-arrow-left"
                            @click="selectedPane = 0"
                        ></el-button>
                        <span>{{ selectedNotification.title }}</span>
                    </div>
                    <div>
                        <div>
                            {{ selectedNotification.body }}
                        </div>
                        <el-row type="flex" justify="end">
                            <el-button
                                v-loading="entityLoading"
                                class="p-5px"
                                size="mini"
                                type="text"
                                @click="goNotification()"
                            >
                                {{ $t('Detail') }}
                                <i class="el-icon-arrow-right" />
                            </el-button>
                        </el-row>
                    </div>
                </el-card>
            </div>
        </el-popover>
    </el-badge>
</template>

<script>
import Collection from '@/lib/data/Collection';
import Notif from '@/data/Notif';
import moment from 'moment';

export default {
    name: 'notifications',
    data() {
        return {
            list: new Collection({
                model: Notif,
                url: '/user/notification/getall',
                method: 'GET',
            }),
            selections: [],
            selectedPane: 0,
            selectedNotification: null,
            activeName: 'unread',
            entityLoading: false,
            popoverVisible: false,
        };
    },
    created() {
        this.getList();
    },
    computed: {
        unreadList() {
            return this.list.filter((item) => item.isUnread);
        },
        readList() {
            return this.list.filter((item) => !item.isUnread);
        },
        context() {
            return this.$store.getters.context;
        },
    },
    methods: {
        reset() {
            this.popoverVisible = false;
            this.selectedPane = 0;
            this.activeName = 'unread';
        },
        getList() {
            this.list.load(true);
        },
        getDateDisplay(date) {
            if (moment(date).diff(new Date(), 'days') == 0) {
                return moment(date).format('HH:mm');
            }
            return moment(date).format('MMM DD');
        },
        handleSelectionChange(selections) {
            this.selections = selections;
        },
        markAllRead() {
            const notif = new Notif();
            notif.markAllRead({
                beforesend: () => {
                    this.loading = true;
                    this.list.forEach((item) => {
                        item.unread_flag = false;
                    });
                },
                complete: () => {
                    this.loading = false;
                },
                failure: () => {
                    this.getList();
                },
            });
        },
        markSelectedAllRead() {
            const notif = new Notif();
            notif.markIdsRead({
                params: {
                    ids: this.selections.map((item) => item.id),
                },
                beforesend: () => {
                    this.loading = true;
                    this.selections.forEach((item) => {
                        item.unread_flag = false;
                    });
                },
                complete: () => {
                    this.loading = false;
                },
                failure: () => {
                    this.getList();
                },
            });
        },
        openDetail(notification) {
            const unreadFlag = notification.unread_flag;
            this.selectedPane = 1;
            this.selectedNotification = notification;
            this.selectedNotification.unread_flag = false;
            this.selectedNotification.mark({
                failure: () => {
                    this.selectedNotification.unread_flag = unreadFlag;
                },
            });
        },
        goNotification() {
            if (
                this.selectedNotification.ref_table === 'claim' ||
                this.selectedNotification.ref_table === 'claim_note'
            ) {
                this.$router.push(`/claim-display/${this.selectedNotification.ref_id}`);
                this.reset();
            } else if (this.selectedNotification.ref_table === 'visit') {
                this.$router.push(`/feeds/${this.selectedNotification.ref_id}`).catch((err) => err);
            }

            this.reset();
        },
    },
};
</script>

<style lang="scss">
.notif-table {
    .el-checkbox,
    .el-radio {
        margin-bottom: 0px !important;
    }
    .notif-row {
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
